import { useState } from 'react';
import { IconLayoutKanban, IconRefresh } from '@tabler/icons-react';
import AppShell from '../components/AppShell';
import { COLORS } from '../utils/uiStyles';
import { Page, PageHeader, PillTabs, Button } from '../components/ui';
import DxAnalytics from './dx/DxAnalytics';
import DxOverdue from './dx/DxOverdue';
import DxWeekly from './dx/DxWeekly';

const TAB_ITEMS = [{ key: 'weekly', label: '주간회의' }, { key: 'analytics', label: '분석' }, { key: 'overdue', label: '일정 경과' }];

export default function DxBoardPage() {
  const [activeTab, setActiveTab] = useState('weekly');
  const [weeklyRefreshKey, setWeeklyRefreshKey] = useState(0);
  const [analyticsRefreshKey, setAnalyticsRefreshKey] = useState(0);
  const [overdueRefreshKey, setOverdueRefreshKey] = useState(0);
  const activeView = ['analytics', 'overdue'].includes(activeTab) ? activeTab : 'weekly';

  const refreshPage = () => {
    if (activeView === 'weekly') {
      setWeeklyRefreshKey((v) => v + 1);
      return;
    }
    if (activeView === 'analytics') {
      setAnalyticsRefreshKey((v) => v + 1);
      return;
    }
    if (activeView === 'overdue') {
      setOverdueRefreshKey((v) => v + 1);
    }
  };

  return (
    <AppShell app="dxboard" style={{ fontFamily: 'var(--gw-font)', background: COLORS.bg }}>
      <main style={{ flex: 1, overflowY: 'auto', minWidth: 0 }}>
        <Page>
          <PageHeader
            icon={IconLayoutKanban}
            tone="purple"
            title="AX 보드"
            actions={<Button variant="secondary" icon={IconRefresh} onClick={refreshPage}>새로고침</Button>}
          />

          <style>{`@keyframes dx-summary-spin{to{transform:rotate(360deg)}}`}</style>
          <PillTabs ariaLabel="AX 보드 보기" idBase="dx-board-view" value={activeView} onChange={setActiveTab} items={TAB_ITEMS} />

          {activeView === 'weekly' && (
            <section role="tabpanel" id="dx-board-view-panel-weekly" aria-labelledby="dx-board-view-tab-weekly">
              <DxWeekly refreshKey={weeklyRefreshKey} />
            </section>
          )}
          {activeView === 'analytics' && (
            <section role="tabpanel" id="dx-board-view-panel-analytics" aria-labelledby="dx-board-view-tab-analytics">
              <DxAnalytics refreshKey={analyticsRefreshKey} />
            </section>
          )}
          {activeView === 'overdue' && (
            <section role="tabpanel" id="dx-board-view-panel-overdue" aria-labelledby="dx-board-view-tab-overdue">
              <DxOverdue refreshKey={overdueRefreshKey} />
            </section>
          )}
        </Page>
      </main>
    </AppShell>
  );
}
